<template>
  <div class="container sign-in">
    <article class="intro">
      <h3 class="tit">{{ theme === 'tv' ? $t('label.empFrontLogin') : $t('label.empLogin') }}</h3>
      <p class="desc" v-html="$t('messages.signInTxt')"></p>
    </article>
    <section class="sign-in-list">
      <ul>
        <li class="lg">
          <a href="#" @click="goPage('LgLogin')" class="focusable" tabindex="0">
            {{ $t('label.lgLogin') }}
          </a>
        </li>
        <li>
          <a href="#" @click="snsLogin('Google')" class="focusable" tabindex="0">
            <i class="google"><span class="sr-only">Google</span></i>
            <span>{{ $t('label.googleLogin') }}</span>
          </a>
        </li>
        <li>
          <a href="#" @click="snsLogin('Facebook')" class="focusable" tabindex="0">
            <i class="facebook"><span class="sr-only">Facebook</span></i>
            <span>{{ $t('label.facebookLogin') }}</span>
          </a>
        </li>
        <li>
          <a href="#" @click="snsLogin('Amazon')" class="focusable" tabindex="0">
            <i class="amazon"><span class="sr-only">Amazon</span></i>
            <span>{{ $t('label.amazonLogin') }}</span>
          </a>
        </li>
        <li v-if="country_code==='KR'">
          <a href="#" @click="snsLogin('Naver')" class="focusable" tabindex="0">
            <i class="naver"><span class="sr-only">Naver</span></i>
            <span>{{ $t('label.naverLogin') }}</span>
          </a>
        </li>
        <div id="naverIdLogin" style="display: none; height: 0; width: 0"></div>
      </ul>
      <b-form class="checkbox-wrap">
        <b-form-checkbox v-model="autoSignIn" v-b-tooltip.hover :title="this.$i18n.t('messages.autoSignInTxt')">{{ $t('label.autoSignIn') }}</b-form-checkbox>
      </b-form>
    </section>
  </div>
</template>

<script>
import {initFbsdk} from '@/3rd_party/facebook_oAuth.js'
import {initAmazonsdk} from '@/3rd_party/amazon_oAuth.js'
import {initNaversdk} from '@/3rd_party/naver_oAuth.js'
import jwtDecode from "jwt-decode";
import session from "@/utils/session";

export default {
  name: 'Login',
  metaInfo() {
    return {
      title: "Login"
    };
  },
  mounted() {
    initFbsdk();
    initAmazonsdk();
    window.addEventListener("keyup", this.backKeyHandler);
  },
  data() {
    return {
      country_code: this.$store.state.country || this.$route.query.country,
      autoSignIn: this.$store.state.login_save || true,
      redirect_uri: this.$store.state.redirect_uri || this.$route.query.redirect_uri,
      account_type: '',
      theme: session.get_theme() || 'tv'
    }
  },
  methods: {
    goPage: function (page) {
      const locale = navigator.language || navigator.userLanguage;
      if (locale.indexOf('CA') < 0) {
        gtag('event', "select_item", {
          'value': page
        });
      }

      this.$router.push({
        name: page,
        query: {
          country: this.country_code || false,
          login_save: this.autoSignIn || false,
          redirect_uri: this.redirect_uri || ''
        }
      });
    },
    backKeyHandler: function (e) {
      if (e.keyCode === 461 || e.keyCode === 0x1CD) {
        let modal = document.querySelectorAll('.modal.show')
        if (modal.length === 0) {
          this.$router.push({
            name: 'Home'
          });
        } else {
          modal[0].parentElement.remove()
        }
      }
    },
    snsAuthorize: function (body) {
      body.country_code = this.country_code;
      body.login_save = this.autoSignIn || false;
      body.redirect_uri = this.redirect_uri;
      this.$axios.post(
          `${process.env.VUE_APP_SNS_REDIRECT_URI}`, body
      ).then(res => {
        if (res.status === 200) {
          this.$toastr.s(this.$t('messages.SignInComplete', {'0': this.$t('label.lgAccount')}))

          const locale = navigator.language || navigator.userLanguage;
          if (locale.indexOf('CA') < 0) {
            gtag('event', "login_complete", {
              "method": this.account_type,
              "country_code": this.country_code,
              "login_save": this.autoSignIn
            });
          }

          setTimeout(() => {
            window.location.href = res.data.location;
          }, 2000)
        }
      }).catch(err => {
        if (err.response.status === 406) {
          const errName = err.response.data.error.name;
          if (errName) {
            let msg = ''
            if (errName === 'WrongCountryCode') {
              msg = this.$t(`messages.${errName}`, {'0': this.$t(`label.${err.response.data.error.message}`)});
            } else {
              msg = this.$t(`messages.${errName}`);
            }
            this.$bvModal.msgBoxOk(msg, {
              okTitle: this.$t('label.ok')
            })
          } else {
            this.error = this.$t(`messages.SignInError`);
          }
        } else {
          this.error = this.$t(`messages.SignInError`);
        }
      });
    },
    snsLogin: function (type) {
      this.account_type = type

      const locale = navigator.language || navigator.userLanguage;
      if (locale.indexOf('CA') < 0) {
        gtag('event', "select_item", {
          'value': type
        });
      }

      switch (type) {
        case 'Google':
          // For TV
          this.$axios.post(
              'https://oauth2.googleapis.com/device/code', 'client_id=' + `${process.env.VUE_APP_GOOGLE_CLIENT_KEY_FOR_TV}` + '&scope=email profile'
          ).then(res => {
            const device_code = res.data.device_code
            // const expires_in = res.data.expires_in
            // const interval = res.data.interval
            const user_code = res.data.user_code
            // const verification_url = res.data.verification_url
            this.$bvModal.msgBoxOk(
                this.$createElement('div', {domProps: {innerHTML: this.$t(`messages.GoogleLoginForTV`) + '<br><br>' + user_code}}),
                {okTitle: this.$t('label.ok')}
            ).then(value => {
              if (value) {
                this.$axios.post('https://oauth2.googleapis.com/token', 'client_id=' + `${process.env.VUE_APP_GOOGLE_CLIENT_KEY_FOR_TV}` + '&client_secret=' + `${process.env.VUE_APP_GOOGLE_SECRET_KEY_FOR_TV}` + '&code=' + device_code + '&grant_type=http://oauth.net/grant_type/device/1.0'
                ).then(res => {
                  console.log(res)
                  const id_token = res.data.id_token
                  this.snsAuthorize({
                    client_id: `${process.env.VUE_APP_GOOGLE_CLIENT_KEY}`,
                    id: jwtDecode(id_token)["sub"],
                    token: res.data.id_token,
                    account_type: "google"
                  })
                }).catch(err => {
                  console.log(err)
                  if (err.response.status === 428) {
                    this.$bvModal.msgBoxOk(this.$t(`messages.LoginErrorForTV`), {
                      okTitle: this.$t('label.ok')
                    })
                  }
                });
              }
            })
          }).catch(err => {
            console.log(err)
          });

          // for PC browser
          // this.$gAuth
          // .signIn()
          // .then(GoogleUser => {
          //   console.log('GoogleUser', GoogleUser)
          //   this.snsAuthorize({
          //     client_id: `${process.env.VUE_APP_GOOGLE_CLIENT_KEY}`,
          //     id: GoogleUser.getId(),
          //     token: GoogleUser.getAuthResponse().id_token,
          //     account_type: "google"
          //   })
          // })
          // .catch(error => {
          //   console.log('error', error)
          // })
          break;
        case 'Facebook':
          // For TV
          this.$axios.post(
              'https://graph.facebook.com/v2.6/device/login', 'access_token=' + `${process.env.VUE_APP_FACEBOOK_CLIENT_KEY}` + '|' + `${process.env.VUE_APP_FACEBOOK_CLIENT_TOKEN}`
          ).then(res => {
            const code = res.data.code
            // const expires_in = res.data.expires_in
            // const interval = res.data.interval
            const user_code = res.data.user_code
            // const verification_uri = res.data.verification_uri
            this.$bvModal.msgBoxOk(
                this.$createElement('div', {domProps: {innerHTML: this.$t(`messages.FacebookLoginForTV`) + '<br><br>' + user_code}}),
                {okTitle: this.$t('label.ok')}
            ).then(value => {
              if (value) {
                this.$axios.post('https://graph.facebook.com/v2.6/device/login_status', 'access_token=' + `${process.env.VUE_APP_FACEBOOK_CLIENT_KEY}` + '|' + `${process.env.VUE_APP_FACEBOOK_CLIENT_TOKEN}` + '&client_secret=' + `${process.env.VUE_APP_GOOGLE_SECRET_KEY_FOR_TV}` + '&code=' + code
                ).then(res => {
                  console.log(res)
                  if ('access_token' in res.data) {
                    const access_token = res.data.access_token
                    this.$axios.get(
                        'https://graph.facebook.com/v2.3/me?fields=token_for_business&access_token=' + access_token
                    ).then(response => {
                      console.log(response)
                      this.snsAuthorize({
                        client_id: `${process.env.VUE_APP_FACEBOOK_CLIENT_KEY}`,
                        id: response.data.token_for_business,
                        token: access_token,
                        account_type: "facebook"
                      })
                    })
                  } else {
                    this.$bvModal.msgBoxOk(this.$t(`messages.LoginErrorForTV`), {
                      okTitle: this.$t('label.ok')
                    })
                  }
                }).catch(err => {
                  console.log(err)
                });
              }
            })
          }).catch(err => {
            console.log(err)
          });

          // for PC browser
          // window.FB.login(response1 => {
          //   console.log('fb response', response1)
          //   const that = this;
          //   FB.api('/me', {fields: 'token_for_business'}, function(response) {
          //     console.log(response);
          //     that.snsAuthorize({
          //       client_id: `${process.env.VUE_APP_FACEBOOK_CLIENT_KEY}`,
          //       id: response.token_for_business,
          //       token: response1.authResponse.accessToken,
          //       account_type: "facebook"
          //     })
          //   })
          // }, this.params)
          break;
        case 'Amazon':
          // For TV
          this.$axios.post(
              'https://api.amazon.com/auth/o2/create/codepair', 'client_id=' + `${process.env.VUE_APP_AMAZON_CLIENT_KEY_FOR_TV}` + '&scope=profile&response_type=device_code'
          ).then(res => {
            const device_code = res.data.device_code
            // const expires_in = res.data.expires_in
            // const interval = res.data.interval
            const user_code = res.data.user_code
            // const verification_uri = res.data.verification_uri
            this.$bvModal.msgBoxOk(
                this.$createElement('div', {domProps: {innerHTML: this.$t(`messages.AmazonLoginForTV`) + '<br><br>' + user_code}}),
                {okTitle: this.$t('label.ok')}
            ).then(value => {
              if (value) {
                this.$axios.post(
                    'https://api.amazon.com/auth/o2/token', 'user_code=' + user_code + '&device_code=' + device_code + '&grant_type=device_code'
                ).then(res => {
                  console.log(res)
                  if ('access_token' in res.data) {
                    const access_token = res.data.access_token
                    this.$axios.get(
                        'https://api.amazon.com/user/profile?access_token=' + access_token
                    ).then(response => {
                      console.log(response)
                      this.snsAuthorize({
                        client_id: `${process.env.VUE_APP_AMAZON_CLIENT_KEY}`,
                        id: response.data.user_id,
                        token: access_token,
                        account_type: "amazon"
                      })
                    })
                  } else {
                    this.$bvModal.msgBoxOk(this.$t(`messages.LoginErrorForTV`), {
                      okTitle: this.$t('label.ok')
                    })
                  }
                }).catch(err => {
                  console.log(err)
                  if (err.response.status === 400) {
                    this.$bvModal.msgBoxOk(this.$t(`messages.LoginErrorForTV`), {
                      okTitle: this.$t('label.ok')
                    })
                  }
                });
              }
            })
          }).catch(err => {
            console.log(err)
          });

          //for PC browser
          // const that = this
          // var options = {}
          // options.scope = 'profile';
          // options.pkce = true; // SDK generates a `code_verifier` and `code_challenge`
          // amazon.Login.authorize(options, function(response) {
          //   console.log(response)
          //   amazon.Login.retrieveToken(response.code, function(response) {
          //     console.log(response)
          //     const access_token = response.access_token
          //     amazon.Login.retrieveProfile(access_token, function(response) {
          //       console.log(response)
          //       that.snsAuthorize({
          //         client_id: `${process.env.VUE_APP_AMAZON_CLIENT_KEY}`,
          //         id: response.profile.CustomerId,
          //         token: access_token,
          //         account_type: "amazon"
          //       })
          //     })
          //   })
          // })
          break;
        case 'Naver':
          initNaversdk(this.autoSignIn, this.redirect_uri);
          document.getElementById("naverIdLogin_loginButton").click();
          break;
      }
    },
  },
  beforeDestroy() {
    window.removeEventListener("keyup", this.backKeyHandler);
  }
}
</script>
